/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const QueryParamStatus = {
  Queued: "queued",
  Generating: "generating",
  ReadyToScore: "ready_to_score",
  Scoring: "scoring",
  Running: "running",
  Completed: "completed",
  Failed: "failed",
} as const;
export type QueryParamStatus = ClosedEnum<typeof QueryParamStatus>;

export type ListEvalSamplesRequest = {
  runId: string;
  after?: string | undefined;
  limit?: number | undefined;
  taskId?: string | undefined;
  model?: string | undefined;
  status?: QueryParamStatus | undefined;
  scoreMetric?: string | undefined;
  scoreMin?: number | undefined;
  scoreMax?: number | undefined;
  includeDatasetRow?: boolean | undefined;
  includeReasoning?: boolean | undefined;
  sampleIndex?: string | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const QueryParamStatus$inboundSchema: z.ZodNativeEnum<
  typeof QueryParamStatus
> = z.nativeEnum(QueryParamStatus);
/** @internal */
export const QueryParamStatus$outboundSchema: z.ZodNativeEnum<
  typeof QueryParamStatus
> = QueryParamStatus$inboundSchema;

/** @internal */
export const ListEvalSamplesRequest$inboundSchema: z.ZodType<
  ListEvalSamplesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  run_id: z.string(),
  after: z.string().optional(),
  limit: z.number().int().default(100),
  task_id: z.string().optional(),
  model: z.string().optional(),
  status: QueryParamStatus$inboundSchema.optional(),
  score_metric: z.string().optional(),
  score_min: z.number().optional(),
  score_max: z.number().optional(),
  include_dataset_row: z.boolean().default(true),
  include_reasoning: z.boolean().default(false),
  sample_index: z.string().optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "run_id": "runId",
    "task_id": "taskId",
    "score_metric": "scoreMetric",
    "score_min": "scoreMin",
    "score_max": "scoreMax",
    "include_dataset_row": "includeDatasetRow",
    "include_reasoning": "includeReasoning",
    "sample_index": "sampleIndex",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListEvalSamplesRequest$Outbound = {
  run_id: string;
  after?: string | undefined;
  limit: number;
  task_id?: string | undefined;
  model?: string | undefined;
  status?: string | undefined;
  score_metric?: string | undefined;
  score_min?: number | undefined;
  score_max?: number | undefined;
  include_dataset_row: boolean;
  include_reasoning: boolean;
  sample_index?: string | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListEvalSamplesRequest$outboundSchema: z.ZodType<
  ListEvalSamplesRequest$Outbound,
  z.ZodTypeDef,
  ListEvalSamplesRequest
> = z.object({
  runId: z.string(),
  after: z.string().optional(),
  limit: z.number().int().default(100),
  taskId: z.string().optional(),
  model: z.string().optional(),
  status: QueryParamStatus$outboundSchema.optional(),
  scoreMetric: z.string().optional(),
  scoreMin: z.number().optional(),
  scoreMax: z.number().optional(),
  includeDatasetRow: z.boolean().default(true),
  includeReasoning: z.boolean().default(false),
  sampleIndex: z.string().optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    runId: "run_id",
    taskId: "task_id",
    scoreMetric: "score_metric",
    scoreMin: "score_min",
    scoreMax: "score_max",
    includeDatasetRow: "include_dataset_row",
    includeReasoning: "include_reasoning",
    sampleIndex: "sample_index",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listEvalSamplesRequestToJSON(
  listEvalSamplesRequest: ListEvalSamplesRequest,
): string {
  return JSON.stringify(
    ListEvalSamplesRequest$outboundSchema.parse(listEvalSamplesRequest),
  );
}
export function listEvalSamplesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListEvalSamplesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListEvalSamplesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListEvalSamplesRequest' from JSON`,
  );
}
